module.exports = __webpack_public_path__ + "img/logo.59db03df.jpg";